module.exports = __webpack_public_path__ + "static/media/calendar-white-small.5bc8e3ec.svg";